import { combineReducers } from 'redux';
import configureStore from './ConfigureStore';
import rootSaga from '../sagas/RootSaga';
import { reducer as journeyPlanReducer } from './JourneyPlan';
import { reducer as liveDepartureReducer } from './LiveDeparture';
import { reducer as timetablesReducer } from './TimetablesRedux';

export default () => {
  const rootReducer = combineReducers({
    journeyPlan: journeyPlanReducer,
    liveDeparture: liveDepartureReducer,
    timetables: timetablesReducer,
  });

  return configureStore(rootReducer, rootSaga);
};
